export enum DYNAMIC_TAG_NAMES {
    ALLOWED_PATHS_WITHOUT_COOKIES = 'ALLOWED_PATHS_WITHOUT_COOKIES',
    COOKIE_REJECT = 'COOKIE_REJECT',
    VALUES_TAG_FOR_JUMIO_POPUP = 'VALUES_TAG_FOR_JUMIO_POPUP',
    FORGOTTEN_PASSWORD = 'FORGOTTTEN_PASSWORD',
    BONUS_CODE_HEADER_URL = 'BONUS_CODE_HEADER_URL',
    PROMOTIONS_URL = 'PROMOTIONS_URL',
    LOSS_LIM = 'LOSSLIM',
    SAFEBET = 'SAFEBET',
    RG_NEEDED = 'RG_NEEDED',
    SOF_NEEDED = 'SOF_NEEDED',
    STICKY_FOOTER_HOME_URL = 'STICKY_FOOTER_HOME_URL',
    STICKY_FOOTER_PROMOTION_URL = 'STICKY_FOOTER_PROMOTION_URL',
    STICKY_FOOTER_DEPOSIT_URL = 'STICKY_FOOTER_DEPOSIT_URL',
    STICKY_FOOTER_HELP_URL = 'STICKY_FOOTER_HELP_URL',
    SAFER_GAMBLING_SHIELD_URL = 'SAFER_GAMBLING_SHIELD_URL',
    GAME_SEARCH_MIN_CHARACTERS = 'GAME_SEARCH_MIN_CHARACTERS',
    BLUEPRINT = 'BLUEPRINT',
    FEED_NAMES_FOR_GAME_INFO = 'FEED_NAMES_FOR_GAME_INFO',
    EXCLUDED_FORCE_LIMITS = 'EXCLUDED_FORCE_LIMITS',
    VERIFICATION_REQUIRED_URL = 'VERIFICATION_REQUIRED_URL',
    GREEN_GAMBLING = 'GREEN_GAMBLING',
    BONUS_HISTORY = 'BONUS_HISTORY',
    STICKY_MENU_WEBCONTENT_ID = 'STICKY_MENU_WEBCONTENT_ID',
    DISABLE_JUMIO_VERIFY_POPUP = 'DISABLE_JUMIO_VERIFY_POPUP',
    COOKIE_SITE_CONSENT_TAG_NAME = 'COOKIE_SITE_CONSENT_TAG_NAME',
    COOKIE_NATIVE_CONSENT_TAG_NAME = 'COOKIE_NATIVE_CONSENT_TAG_NAME',
    RECENTLY_PLAYED_CUSTOM = 'RECENTLY_PLAYED_CUSTOM',
    PRODUCT_CONTACT_PREFERENCES = 'PRODUCT_CONTACT_PREFERENCES',
    REGISTRATION_SURVEY_TAG_NAME = 'REGISTRATION_SURVEY_TAG_NAME',
}
